<div class="split-container" #containerSplitScreen>
  @if (widthHeighBeforBreakPoint; as width) {
    <div class="split-child-sx" [ngStyle]="{width:width.sx}">
      <ng-content select="[sx]">
      </ng-content>
    </div>
    <div class="split-child-dx" [ngStyle]="{width:width.dx}">
      <ng-content select="[dx]">
      </ng-content>
    </div>
  } @else {
    <div class="split-child-sx" style="width: 50%">
      <ng-content select="[sx]">
      </ng-content>
    </div>
    <div class="split-child-dx" style="width: 50%">
      <ng-content select="[dx]">
      </ng-content>
    </div>
  }
</div>